export const NAV_ITEM_LABEL_CHAR_LIMIT = 16;
